import {
  takeLatest, put, call,
} from 'redux-saga/effects';
import api from 'store/api';
import { toast } from 'react-toastify';
import { URL } from '../../../constants/url';
import actionTypes from '../actionTypes';

export function* getSimilar({ payload }) {
  const {
    limit,
    stackSize,
    position,
    handType,
    tableHand,
    sort,
    category,
    game,
    ggps,
    isFreeUser,
  } = payload;
  try {
    const defineEndpoint = () => {
      if (sessionStorage.getItem('isPlo5') === 'true') return URL.GET_SIMILARPLO5;
      if (isFreeUser) return URL.GET_SIMILAR_FREE;
      return URL.GET_SIMILAR;
    };

    const res = yield call(api, {
      method: 'post',
      url: defineEndpoint(),
      data: {
        ts: limit.value,
        bb: stackSize.value,
        stake: position.replace('  ', ''),
        hand: handType,
        sort: sort || 'raise',
        table_hand: tableHand,
        category: category.toLowerCase().replace(' ', ''),
        game,
        gg: ggps === 'gg',
      },
    });
    if (!res?.data) throw new Error('Could not load similar hands. Please try again.');
    yield put({ type: 'GET_SIMILAR_SUCCESS', payload: res.data });
  } catch (e) {
    const message = e?.message || 'Could not load similar hands. Please try again.';
    yield call(toast.error, message);
    yield put({ type: 'GET_SIMILAR_ERROR', error: message });
  }
}

export default function* listener() {
  yield takeLatest(
    (action) => action.type === actionTypes.GET_SIMILAR
      || action.type === 'GET_SIMILAR_DROP'
      // New Hand and settings changes clear review with this success action.
      // They must also cancel the previous query before it can refill the panel.
      || (action.type === 'GET_SIMILAR_SUCCESS'
        && action.payload?.percentage === null && action.payload?.similar?.length === 0),
    function* handleRequest(action) {
      if (action.type === actionTypes.GET_SIMILAR) yield call(getSimilar, action);
    },
  );
}
